import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import ClientAdd from './ClientAdd';
import ClientActionPlan from './ClientActionPlan';
import ScheduleMessage from './ScheduleMessage';
import SearchInput from './../SearchInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import LoadMoreIcon from './../LoadMoreIcon';
import Search from './../workouts/search';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faTasks, faClock } from '@fortawesome/free-solid-svg-icons'

import _ from 'lodash';

const ClientsListing = props => {
	const {
		clientType,
		groups,
		clients,
		formData,
		onChange,
		newGroupName,
		showAddModal,
		showActionModal,
		showScheduleMessageModal,
		hideAddModal,
		hideActionModal,
		hideScheduleMessageModal,
		isOpenAddModal,
		isOpenActionModal,
		isOpenScheduleMessageModal,
		selectedClientEmail,
		onSave,
		isLoadMore,
		fetchMore,
		newClientId,
		fetchActions,
		fetchActionRanges,
		fetchBodyMatrixRanges,
		fetchMileStones,
		fetchPARQS,
		fetchScheduleCall,
		saveBodyMatrix,
		saveWeightMatric,
		fetchBodyMatrix,
		fetchWeightMetric,
		fetchWeightMetricRanges,
		fetchBodyMatrixMetas,
		saveClientAction,
		saveScheduleMessage,
		deleteScheduleMessage,
		deleteWeightMetricRange,
		deleteWeightMetric,
		fetchScheduleMessages,
		fetchScheduleMessageDetail,
		saveMileStones,
		deleteMileStones,
		savePARQ,
		deletePARQ,
		updateActionStatus,
		saveScheduleCall,
		saveClientSubAction,
		deleteActionRange,
		deleteBodyMatrixRange,
		user,
		isMobile
	} = props;

	const [search, setSearch] = useState('');
	const [clientList, setClientList] = useState([]);


	// create refs for each client to handle scroll
	const clientRefs = clients.reduce((acc, value) => {
		acc[value._id] = React.createRef();
		return acc;
	}, {});

	// create refs for each group to handle scroll
	const groupRefs = groups.reduce((acc, value) => {
		acc[value._id] = React.createRef();
		return acc;
	}, {});

	useEffect(() => {
	  setClientList(clients);
	}, [clients])

	useEffect(() => {
		searchClient(search);
	}, [search])


	const searchClient = useCallback(_.debounce((term) => {
        fetchMore({
			skip: 0,
			search: term
		})
    }, 1000), []);



	// scroll to the newly created client from the list
	useEffect(() => {
		if (clientType === 'clients') {
			clientRefs[newClientId] &&
				clientRefs[newClientId].current &&
				clientRefs[newClientId].current.scrollIntoView({
					block: 'center',
				});
		} else if (clientType === 'groups') {
			groupRefs[newClientId] &&
				groupRefs[newClientId].current &&
				groupRefs[newClientId].current.scrollIntoView({
					block: 'center',
				});
		}
	}, [clientRefs, groupRefs, clientType]);

	if (clientType === 'groups') {
		let groupsArr = [...groups];
		groupsArr = _.orderBy(groupsArr, ['name'],['asc']);
		return (
			<div style={{ marginBottom: 10, marginTop: 10 }}>
				{isOpenAddModal && (
					<ClientAdd
						clientType={clientType}
						isEdit={false}
						hideAddModal={hideAddModal}
						isOpenAddModal={isOpenAddModal}
						onChange={onChange}
						formData={formData}
						isMobile={isMobile}
						newGroupName={newGroupName}
						onSave={() => onSave()}
					/>
				)}
				<FormControl component="fieldset">
					<FormLabel component="legend">Groups</FormLabel>
					<Button
						color="primary"
					
						onClick={showAddModal}
						style={{
							width: '150px',
						}}
					>
						<ButtonContent text="Add Group" icon="plus" />
					</Button>
					<FormGroup>
						<div className="assign-scroll">
						<InfiniteScroll
									dataLength={groupsArr.length} //This is important field to render the next data
									next={() => fetchMore({
										skip: groupsArr.length,
										search: search
									})}
									hasMore={isLoadMore}
									scrollableTarget="scrollableClients"
									loader={
										<LoadMoreIcon/>
									}
							>
							{groupsArr.map(group => (
								<Fragment>
									<div ref={groupRefs[group._id]} style={{
										marginLeft: '2px'
									}}>
										<FormControlLabel
											key={group._id}
											control={
												<Checkbox
													checked={formData.groupIds.includes(
														group._id.toString()
													)}
													onChange={props.onChangeGroupIds('groupIds', group)}
													value={group._id.toString()}
												/>
											}
											label={group.name}
										/>
										<span
											className="link"
											onClick={() => showAddModal(group)}
											style={{ float: 'right' }}
										>
											<FontAwesomeIcon
												icon="edit"
												title={'Edit'}
												style={{ marginRight: 5, color: COLORS.orange }}
											/>
										</span>
									</div>
								</Fragment>
							))}
						</InfiniteScroll>
						</div>
					</FormGroup>
					<FormHelperText
						component={() => (
							<span style={{ marginTop: 10, color: COLORS.orange }}>
								{groupsArr.length
									? `Select Groups of clients to Assign`
									: `You don't have any groups. Add Emails and save them to create your first group!`}
							</span>
						)}
					/>
				</FormControl>
			</div>
		);
	}
	if (clientType === 'clients') {
		let clientsArr = [...clientList];
		clientsArr = _.orderBy(clientsArr, ['firstName'],['asc']);
		return (
			<Fragment>

			<div style={{ marginBottom: 10, marginTop: 10 }}>
				{ isOpenActionModal && (
				<ClientActionPlan
						clientType={clientType}
						isEdit={false}
						hideActionModal={hideActionModal}
						isOpenAddModal={isOpenActionModal}
						fetchActions = { fetchActions}
						fetchMileStones = { fetchMileStones }
						deleteWeightMetricRange = { deleteWeightMetricRange }
						fetchPARQS = { fetchPARQS }
						fetchScheduleCall = { fetchScheduleCall }
						saveBodyMatrix = { saveBodyMatrix}
						saveWeightMatric = { saveWeightMatric }
						fetchBodyMatrixMetas = { fetchBodyMatrixMetas }
						fetchBodyMatrix = { fetchBodyMatrix }
						fetchWeightMetric = { fetchWeightMetric }
						fetchActionRanges = { fetchActionRanges }
						fetchBodyMatrixRanges = { fetchBodyMatrixRanges }
						fetchWeightMetricRanges = { fetchWeightMetricRanges }
						clientEmail = {selectedClientEmail}
						saveClientAction = { saveClientAction}
						saveMileStones = { saveMileStones}
						savePARQ = { savePARQ}
						saveScheduleCall = { saveScheduleCall}
						deleteMileStones = { deleteMileStones }
						deletePARQ = { deletePARQ }
						updateActionStatus = { updateActionStatus }
						deleteActionRange = { deleteActionRange }
						deleteBodyMatrixRange = {deleteBodyMatrixRange}
						user = {user}
						isMobile = {isMobile}
			  		/>
				)}

				{ isOpenScheduleMessageModal && (
					<ScheduleMessage
							clientType={clientType}
							isEdit={false}
							hideActionModal={hideScheduleMessageModal}
							isOpenAddModal={isOpenScheduleMessageModal}
							clientEmail = {selectedClientEmail}
							saveScheduleMessage = { saveScheduleMessage}
							deleteScheduleMessage = { deleteScheduleMessage }
							fetchScheduleMessages = { fetchScheduleMessages}
							fetchScheduleMessageDetail = { fetchScheduleMessageDetail }
							user = {user}
							isMobile = {isMobile}
						/>
				)}


				{isOpenAddModal && (
					<ClientAdd
						clientType={clientType}
						isEdit={false}
						hideAddModal={hideAddModal}
						isOpenAddModal={isOpenAddModal}
						onChange={onChange}
						isMobile={isMobile}
						formData={formData}
						onSave={() => onSave()}
					/>
				)}
				<FormControl component="fieldset">


					<Fragment>
					{!isMobile && <FormLabel component="legend">Clients</FormLabel>}

						<Button
							color="primary"
						
							onClick={() => showAddModal()}
							style={isMobile ?  {
								width: '150px',
								padding: 20,
								paddingLeft: 0
							}: {
								width: '120px',
							}}
						>
							<ButtonContent text="Add Client" icon="plus" />
						</Button>

					</Fragment>


					<SearchInput
						value={search}
						label = "Search By First Name"
						onChange={e =>
							setSearch(e.target.value)
						}
						style={{ width: '100%', marginRight: '5%' }}
					/>

					<FormGroup>
						<div className="assign-scroll" id="scrollableClients">
							<InfiniteScroll
									dataLength={clientsArr.length} //This is important field to render the next data
									next={() => fetchMore({
										skip: clientsArr.length,
										search: search
									})}
									hasMore={isLoadMore}
									scrollableTarget="scrollableClients"
									loader={
										<LoadMoreIcon/>
									}
							>
							{clientsArr.map(client => (
								<Fragment>
									<div ref={clientRefs[client._id]} style={{
										marginLeft: '2px'
									}}>
										{ !isMobile && (
										<FormControlLabel
											key={client._id}
											control={
												<Checkbox
													checked={formData.clientIds.includes(
														client._id.toString()
													)}
													onChange={props.onChangeGroupIds('clientIds', client)}
													value={client._id.toString()}
												/>
											}
											label={`${client.firstName} ${client.lastName}`}
										/>) }
										{ isMobile && (
										<FormControlLabel
											style = {{
												marginLeft: '-40px',
											}}
											key={client._id}
											label={`${client.firstName} ${client.lastName}`}
											control={
												<Checkbox
													checked={formData.clientIds.includes(
														client._id.toString()
													)}
													style = {{
														visibility: 'hidden',
													}}
													onChange={props.onChangeGroupIds('clientIds', client)}
													value={client._id.toString()}
												/>
											}
										/>) }

										<Fragment>
										<span
											className="link"
											onClick={() => showAddModal(client)}
											style={isMobile ? { float: 'right', marginTop: '5px', padding: '0 10px' }: { float: 'right', marginTop: '10px' }}
										>
											<FontAwesomeIcon
												icon="edit"
												title={'Edit'}
												size={isMobile && "2x" }
												style={{ marginRight: 5, color: COLORS.orange }}
											/>
										</span>
										{ !isMobile &&
										<span
										className="link"
										onClick={() => showScheduleMessageModal(client)}
										style={{ float: 'right', marginTop: '10px' }}
										>
											<FontAwesomeIcon
												icon={faClock}
												title={'Action'}
												style={{ marginRight: 5, color: COLORS.orange }}
											/>
										</span>
										}
										</Fragment>


										<span
											className="link"
											onClick={() => showActionModal(client)}
											style={{ float: 'right', marginTop: isMobile ? '5px' : '10px' }}
										>
											<FontAwesomeIcon
												icon={faTasks}
												title={'Action'}
												size={isMobile && "2x" }
												style={{ marginRight: 5, color: COLORS.orange }}
											/>
										</span>
									</div>
								</Fragment>
							))}
					</InfiniteScroll>
						</div>
					</FormGroup>
					<FormHelperText
						component={() => (
							<span style={{ marginTop: 10, color: COLORS.orange }}>
								{clientsArr.length
									? !isMobile ? `Select a client to Assign` : ''
									: `You don't have any clients. Add Email and save them to create a client!`}
							</span>
						)}
					/>
				</FormControl>
			</div>
			</Fragment>
		);
	}
	return null;
};

export default ClientsListing;



// WEBPACK FOOTER //
// ./src/components/assignments/ClientsListing.js